var map = {
	"./after-hours.jpg": 623,
	"./apple-icon.png": 624,
	"./bg1.jpg": 237,
	"./bg11.jpg": 238,
	"./bg3.jpg": 101,
	"./bg4.jpg": 625,
	"./bg5.jpg": 239,
	"./bg62.jpg": 626,
	"./bg7.jpg": 64,
	"./bg8.jpg": 65,
	"./blurred-image-1.jpg": 627,
	"./career-image.jpg": 628,
	"./career-large.jpg": 629,
	"./career.jpg": 630,
	"./creative-tim-white-slim2.png": 631,
	"./default-avatar.png": 632,
	"./doc-patient-stethoscope.jpg": 633,
	"./doctor-patient-consultation.jpg": 102,
	"./eva.jpg": 634,
	"./favicon.png": 635,
	"./flags/AD.png": 636,
	"./flags/AE.png": 637,
	"./flags/AG.png": 638,
	"./flags/AM.png": 639,
	"./flags/AR.png": 640,
	"./flags/AT.png": 641,
	"./flags/AU.png": 642,
	"./flags/BE.png": 643,
	"./flags/BF.png": 644,
	"./flags/BG.png": 645,
	"./flags/BO.png": 646,
	"./flags/BR.png": 647,
	"./flags/CA.png": 648,
	"./flags/CD.png": 649,
	"./flags/CG.png": 650,
	"./flags/CH.png": 651,
	"./flags/CL.png": 652,
	"./flags/CM.png": 653,
	"./flags/CN.png": 654,
	"./flags/CO.png": 655,
	"./flags/CZ.png": 656,
	"./flags/DE.png": 657,
	"./flags/DJ.png": 658,
	"./flags/DK.png": 659,
	"./flags/DZ.png": 660,
	"./flags/EE.png": 661,
	"./flags/EG.png": 662,
	"./flags/ES.png": 663,
	"./flags/FI.png": 664,
	"./flags/FR.png": 665,
	"./flags/GA.png": 666,
	"./flags/GB.png": 667,
	"./flags/GM.png": 668,
	"./flags/GT.png": 669,
	"./flags/HN.png": 670,
	"./flags/HT.png": 671,
	"./flags/HU.png": 672,
	"./flags/ID.png": 673,
	"./flags/IE.png": 674,
	"./flags/IL.png": 675,
	"./flags/IN.png": 676,
	"./flags/IQ.png": 677,
	"./flags/IR.png": 678,
	"./flags/IT.png": 679,
	"./flags/JM.png": 680,
	"./flags/JO.png": 681,
	"./flags/JP.png": 682,
	"./flags/KG.png": 683,
	"./flags/KN.png": 684,
	"./flags/KP.png": 685,
	"./flags/KR.png": 686,
	"./flags/KW.png": 687,
	"./flags/KZ.png": 688,
	"./flags/LA.png": 689,
	"./flags/LB.png": 690,
	"./flags/LC.png": 691,
	"./flags/LS.png": 692,
	"./flags/LU.png": 693,
	"./flags/LV.png": 694,
	"./flags/MG.png": 695,
	"./flags/MK.png": 696,
	"./flags/ML.png": 697,
	"./flags/MM.png": 698,
	"./flags/MT.png": 699,
	"./flags/MX.png": 700,
	"./flags/NA.png": 701,
	"./flags/NE.png": 702,
	"./flags/NG.png": 703,
	"./flags/NI.png": 704,
	"./flags/NL.png": 705,
	"./flags/NO.png": 706,
	"./flags/OM.png": 707,
	"./flags/PA.png": 708,
	"./flags/PE.png": 709,
	"./flags/PG.png": 710,
	"./flags/PK.png": 711,
	"./flags/PL.png": 712,
	"./flags/PT.png": 713,
	"./flags/PY.png": 714,
	"./flags/QA.png": 715,
	"./flags/RO.png": 716,
	"./flags/RU.png": 717,
	"./flags/RW.png": 718,
	"./flags/SA.png": 719,
	"./flags/SE.png": 720,
	"./flags/SG.png": 721,
	"./flags/SL.png": 722,
	"./flags/SN.png": 723,
	"./flags/SO.png": 724,
	"./flags/SV.png": 725,
	"./flags/TD.png": 726,
	"./flags/TJ.png": 727,
	"./flags/TL.png": 728,
	"./flags/TR.png": 729,
	"./flags/TZ.png": 730,
	"./flags/UA.png": 731,
	"./flags/US.png": 732,
	"./flags/VE.png": 733,
	"./flags/VN.png": 734,
	"./flags/YE.png": 735,
	"./flu-vaccines-badge.png": 736,
	"./follow-us-on-facebook.png": 160,
	"./gpv-bulk-billed-medical-centre.png": 737,
	"./gpv-news.jpg": 738,
	"./gpv-opening-hours.jpg": 739,
	"./gpv-private-billed-medical-centre.png": 740,
	"./gpv-telehealth-service.jpg": 741,
	"./gpv-telehealth-service2.jpg": 742,
	"./gpv-telehealth.png": 743,
	"./gpv.png": 744,
	"./header.jpg": 745,
	"./hero-image-1.png": 746,
	"./hero-image-2.png": 747,
	"./hero-image-3.png": 748,
	"./hotdoc-horz.png": 749,
	"./hotdoc1.png": 750,
	"./invision-white-slim.png": 751,
	"./julie.jpg": 752,
	"./landing.jpg": 753,
	"./login.jpg": 754,
	"./logo-square.jpg": 755,
	"./logo.png": 756,
	"./new-patients-welcome2.png": 757,
	"./news/alzheimers-dementia-news.jpg": 173,
	"./news/appointments-available-news.jpg": 174,
	"./news/atagi-covid-news.jpg": 175,
	"./news/beyond-blue-news.jpg": 176,
	"./news/blue-september-prostate-cancer-news.jpg": 177,
	"./news/book-your-flu-shot-news.jpg": 178,
	"./news/bowel-cancer-news.jpg": 179,
	"./news/breast-cancer-news.jpg": 180,
	"./news/cancer-and-covid-19-news.jpg": 181,
	"./news/cancer-symptoms-trials-news.jpg": 182,
	"./news/covid-19-covidsafe-news.jpg": 183,
	"./news/covid-19-isolation-tips-news.jpg": 184,
	"./news/covid-19-news.jpg": 185,
	"./news/covid-19-protect-yourself-news.jpg": 186,
	"./news/covid-19-symptoms-news.jpg": 187,
	"./news/covid-19-wearing-masks-news.jpg": 188,
	"./news/covid19-vaccines1-news.jpg": 189,
	"./news/dr-tharuka2-news.jpg": 190,
	"./news/endometriosis-concern-news.jpg": 191,
	"./news/flu-vaccines-news.jpg": 192,
	"./news/gps-on-vermont-medical-centre-news.jpg": 193,
	"./news/happy-Anniversary-news.jpg": 194,
	"./news/heart-attack-symptoms-news.jpg": 195,
	"./news/heat-stress-news.jpg": 196,
	"./news/how-are-you-managing-your-mental-health-news.jpg": 197,
	"./news/life-logo-news.jpg": 198,
	"./news/lung-cancer-screening-news.jpg": 199,
	"./news/medicare-news.jpg": 200,
	"./news/menopause-perimenopause-assessments-news.jpg": 201,
	"./news/mental-health-news.jpg": 202,
	"./news/mosquito-template.png": 203,
	"./news/mymedicare-news.jpg": 204,
	"./news/nsw-vic-border-closure-news.jpg": 205,
	"./news/pneumonia-vaccine-news.jpg": 206,
	"./news/poison-medication-heatwave-news.jpg": 207,
	"./news/prevent-hpv-cancer-news.jpg": 208,
	"./news/prostate-check-up-news.jpg": 209,
	"./news/q-fever-news.jpg": 210,
	"./news/skin-cancer-news.jpg": 211,
	"./news/sleep-apnoea-news.jpg": 212,
	"./news/sleep-deprivation-news.jpg": 213,
	"./news/stop-vaping-news.jpg": 214,
	"./news/symptoms-of-menopause-news.jpg": 215,
	"./news/telehealth-news.jpg": 216,
	"./news/vaccine-shot-1-news.jpg": 217,
	"./news/weight-loss-doctor-news.jpg": 218,
	"./news/winter-vaccines-news.jpg": 219,
	"./news/xmas-tree-news.jpg": 220,
	"./news/yellow-fever-news.jpg": 221,
	"./news/yes-we-are-open-news.jpg": 222,
	"./not-found.jpg": 240,
	"./now-logo.png": 758,
	"./our-services-people.jpg": 759,
	"./profile.jpg": 760,
	"./q-fever-badge.png": 761,
	"./ryan.jpg": 241,
	"./services/aboriginalflag.svg": 223,
	"./services/care.svg": 224,
	"./services/child.svg": 225,
	"./services/headbrain.svg": 226,
	"./services/medal.svg": 227,
	"./services/medication.svg": 228,
	"./services/nucleo-logo.svg": 229,
	"./services/pill.svg": 230,
	"./services/rainbow.svg": 231,
	"./services/skincheck.svg": 232,
	"./services/stethoscope.svg": 233,
	"./services/travel.svg": 234,
	"./services/vaccine.svg": 235,
	"./services/worker.svg": 236,
	"./staff/Annette-Baumgarten.jpg": 242,
	"./staff/Bayleigh-Reedy.jpg": 243,
	"./staff/Evie-Frawley.jpg": 244,
	"./staff/Jen-Walker.jpg": 245,
	"./staff/Lara-Hopkins.jpg": 246,
	"./staff/Liz-Caunt.jpg": 247,
	"./staff/Megan-Chick.jpg": 248,
	"./staff/Rebecca-Smith.jpg": 249,
	"./staff/Summer-Matthews.jpg": 250,
	"./staff/avatar.jpg": 251,
	"./staff/dr-barkas.jpg": 252,
	"./staff/dr-carmen-padilla-old.jpg": 253,
	"./staff/dr-carmen-padilla.jpg": 254,
	"./staff/dr-douse-old.jpg": 255,
	"./staff/dr-douse.jpg": 256,
	"./staff/dr-hooman.jpg": 257,
	"./staff/dr-lokuketagoda-old.jpg": 258,
	"./staff/dr-lokuketagoda.jpg": 259,
	"./staff/dr-manthi.jpg": 260,
	"./staff/dr-ramsay-old.jpg": 261,
	"./staff/dr-ramsay.jpg": 262,
	"./staff/dr-sampath-old.jpg": 263,
	"./staff/dr-sampath.jpg": 264,
	"./staff/dr-tharuka-old.jpg": 265,
	"./staff/dr-tharuka.jpg": 266,
	"./staff/dr-virajinee-old.jpg": 267,
	"./staff/dr-virajinee.jpg": 268,
	"./travel-immunisation-badge.png": 762,
	"./yellow-fever-badge.png": 763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;